<!-- 内容管理 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div class="mod-sys__position">
      <el-form label-position="top"
               :inline="true"
               :model="dataForm">
        <el-row class="margb10">
          <!-- 文章标题 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('content.contentTitle')">
              <el-input v-model="dataForm.contentTitle"
                        :placeholder="$t('content.contentTitle')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 栏目 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('content.contentColumn')">
              <el-select v-model="dataForm.contentColumn"
                         clearable
                         :placeholder="$t('content.contentColumn')">
                <el-option v-for="(item,index) in contentColumnArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 发布状态 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('content.contentPubStatus')">
              <el-select v-model="dataForm.contentPubStatus"
                         clearable
                         :placeholder="$t('content.contentPubStatus')">
                <el-option v-for="(item,index) in contentPubStatusArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 作者 -->
          <el-col :span="5"
                  class="padt5">
            <el-form-item :label="$t('content.contentAuthor')">
              <el-input v-model="dataForm.contentAuthor"
                        :placeholder="$t('content.contentAuthor')"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-col :span="24">
              <el-button style="margin-bottom: 7px"
                         class="M-search"
                         type="primary"
                         @click="query()">{{ $t('query') }}</el-button>
            </el-col>
            <el-col :span="24">
              <el-button class="el-back M-search M-margin-l"
                         type="info"
                         @click="reset()">{{ $t('reset') }}</el-button>
            </el-col>
          </el-col>
        </el-row>
        <div v-show="isShow">
          <el-row class="margb10">
            <!-- 发布时间 -->
            <el-col :span="10"
                    class="padt5">
              <el-form-item :label="$t('content.publishDate')"
                            style="width: 100%!important;">
                <el-date-picker v-model="dataForm.publishDateModify"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                :start-placeholder="$t('organization.startData')"
                                :end-placeholder="$t('organization.endData')"
                                :clearable="true"
                                :editable='false'
                                style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <ToggleDiv @toggle="toggle"></ToggleDiv>
      <div class="btn-left">
        <!-- 新增按钮 -->
        <el-button v-if="$hasPermission('AUTH000084')"
                   type="primary"
                   @click="addUpdate()">{{ $t('add') }}</el-button>
      </div>
      <!-- 新闻表格 -->
      <el-table v-loading="dataListLoading"
                :data="dataList"
                border
                style="width: 100%;">
        <!-- 栏目 -->
        <el-table-column prop="contentColumn"
                         :label="$t('content.contentColumn')"
                         :formatter="contentColumnFormatter"
                         width="120"
                         header-align="center"></el-table-column>
        <!-- 文章标题 -->
        <el-table-column prop="contentTitle"
                         :label="$t('content.contentTitle')"
                         width="300"
                         header-align="center"></el-table-column>
        <!-- 日期 -->
        <el-table-column prop="contentDate"
                         :label="$t('content.contentDate')"
                         :formatter="contentDateFormatter"
                         width="130"
                         header-align="center"></el-table-column>
        <!-- 作者 -->
        <el-table-column prop="contentAuthor"
                         :label="$t('content.contentAuthor')"
                         width="100"
                         header-align="center"></el-table-column>
        <!-- 发布时间 -->
        <el-table-column prop="publishDate"
                         :label="$t('content.publishDate')"
                         width="200"
                         header-align="center"></el-table-column>
        <!-- 发布人 -->
        <el-table-column prop="publisherName"
                         :label="$t('content.publisherId')"
                         width=""
                         header-align="center"></el-table-column>
        <!-- 发布状态 -->
        <el-table-column prop="contentPubStatus"
                         :label="$t('content.contentPubStatus')"
                         :formatter="contentPubStatusFormatter"
                         width=""
                         header-align="center"></el-table-column>
        <!-- 操作 -->
        <el-table-column fixed="right"
                         align="center"
                         width="100"
                         :label="$t('handle')">
          <template slot-scope="scope">
            <el-dropdown trigger="click"
                         placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="$hasPermission('AUTH000088') && scope.row.contentPubStatus === '10'"
                                  @click.native="clickCancel(scope.row)">下架</el-dropdown-item>
                <el-dropdown-item v-if="$hasPermission('AUTH000086') && scope.row.contentPubStatus === '20'"
                                  @click.native="clickPublish(scope.row)">发布</el-dropdown-item>
                <el-dropdown-item v-if="$hasPermission('AUTH000085') && scope.row.contentPubStatus === '20'"
                                  @click.native="clickEdit(scope.row)">{{ $t('update') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination :current-page="page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="limit"
                     :total="total"
                     layout="total, sizes, prev, pager, next, jumper"
                     @size-change="pageSizeChangeHandle"
                     @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import Vue from 'vue'
import debounce from 'lodash/debounce'
import ToggleDiv from '@/components/toggle-div'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/commcontent/list',
        getDataListIsPage: true,
      },
      contentPubStatusArr: this.enums['contentPubStatus'],
      contentColumnArr: this.enums['contentColumn'],
      dataList: [],
      dataListLoading: false,
      dataForm: {
        publishDateModify: [],
        publishDateStart: '',
        publishDateEnd: '',
      },
      isShow: false,
    }
  },
  components: {
    ToggleDiv
  },
  methods: {
    query() {
      this.page = 1
      this.getDataListMerge()
    },
    reset() {
      this.page = 1
      this.dataForm = {
        publishDateModify: [],
        publishDateStart: '',
        publishDateEnd: '',
      }
      this.getDataListMerge()
    },
    getDataListMerge() {
      this.page = 1
      if (this.dataForm.publishDateModify !== [] && this.dataForm.publishDateModify) {
        if (this.dataForm.publishDateModify.length === 2) {
          this.dataForm.publishDateStart = this.dataForm.publishDateModify[0]
          this.dataForm.publishDateEnd = this.dataForm.publishDateModify[1]
        }
      } else {
        this.dataForm.publishDateStart = ''
        this.dataForm.publishDateEnd = ''
      }
      this.getDataList()
    },
    // 栏目
    contentColumnFormatter(row) {
      return Vue.filter('coverEnum')(row.contentColumn, 'contentColumn')
    },
    // 日期
    contentDateFormatter(row) {
      if (row.contentDate && row.contentDate !== '') {
        return Vue.filter('formatDateNoTime')(row.contentDate)
      } else {
        return ''
      }
    },
    // 发布状态
    contentPubStatusFormatter(row) {
      return Vue.filter('coverEnum')(row.contentPubStatus, 'contentPubStatus')
    },
    // 展开更多
    toggle(data) {
      this.isShow = data
    },
    // 取消
    clickCancel: debounce(function (row) {
      let dataForm = {}
      dataForm.id = row.id
      dataForm.contentPubStatus = '20'
      dataForm.publisherId = null
      this.$request.post('/sys/commcontent/unpublish',
        dataForm
      ).then((res, total, code, data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.getDataList()
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }, 2000, { 'leading': true, 'trailing': false }),
    // 发布
    clickPublish: debounce(function (row) {
      let dataForm = {}
      dataForm.id = row.id
      dataForm.contentPubStatus = '10'
      dataForm.publisherId = this.getStorage(this.GLOBAL.USER_DATA).userId
      this.$request.post('/sys/commcontent/publish',
        dataForm
      ).then((res, total, code, data) => {
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.getDataList()
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    }, 2000, { 'leading': true, 'trailing': false }),
    // 新增
    addUpdate() {
      this.$router.push({
        name: 'sys-content-add-or-update'
      })
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_CONTENT, 'activated')
    },
    // 编辑
    clickEdit(row) {
      this.$router.push({
        name: 'sys-content-add-or-update',
        query: {
          id: row.id
        }
      })
      this.$eventHub.$emit(this.GLOBAL.ACTIVATED_CONTENT, 'activated')
    }
  }
}
</script>
